module.exports = __webpack_public_path__ + "static/media/kasikira.0f18e7d3.jpg";